import { CommonModule } from '@angular/common';
import { Component, EventEmitter, NgModule, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BxEditorToolbarItems } from '@buildxact/ui-components/bx-editor';
import { FormStatus } from '@buildxact/ui-components/shared';
import { NgSelectModule } from '@ng-select/ng-select';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EntityAspect } from 'breeze-client';
import _ from 'lodash';
import moment from 'moment';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { EMPTY, forkJoin } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { Uuid } from '../../../../../graphql';
import { BxUnverifiedAlertService } from '../../../../core/services/bx-unverified-alert.service';
import { CataloguesService } from '../../../../core/services/catalogues.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { HelperService } from '../../../../core/services/helper.service';
import { StoresService } from '../../../../core/services/stores';
import { Round } from '../../../../data/logic/math.functions';
import { TaxService, TaxTypeEnum } from '../../../../data/logic/tax.service';
import {
    Estimate,
    EstimateItem,
    IntegrationConnectionQuoteRequestDetailsModel,
    Job,
    JobItem,
    QuoteRequest,
    QuoteRequestItem,
    QuoteRequestRecipeItem,
} from '../../../../data/models';
import { RepoCommonService } from '../../../../data/repositories/repo-common.service';
import { RepoContactsService, viewableContact } from '../../../../data/repositories/repo-contacts.service';
import { RepoEstimatesService } from '../../../../data/repositories/repo-estimates.service';
import { RepoJobsService } from '../../../../data/repositories/repo-jobs.service';
import { RepoPlansService } from '../../../../data/repositories/repo-plans.service';
import { RepoQuoteRequestsService } from '../../../../data/repositories/repo-quoterequests.service';
import { RepoSettingsService } from '../../../../data/repositories/repo-settings.service';
import { RepoStorageService, StorageContainer, StorageFile } from '../../../../data/repositories/repo-storage.service';
import { BreezeEntity } from '../../../../data/services/breeze/breeze.service';
import { SharedDataService } from '../../../../data/services/shared-data.service';
import { BreezeCase } from '../../../../utils/types/convert-case';
import { ContactsService } from '../../../contacts/contacts.service';
import { BxEditorBase } from '../../../estimates/custom-layouts/domain/entities/bx-editor-base';
import { EstimateMeasurementApisService } from '../../../estimates/estimate-view/plans/measurement/feat-estimate-measurements-v2/domain';
import { EmailSendersService } from '../../../messages/email/domain/apis/email-senders.service';
import { EmailListItem } from '../../../messages/email/domain/apis/queries/email-types';
import { ContactType } from '../../../messages/ui-contact-selector/ui-contact-selector.component';
import { QuoteRequestManagePresetModule } from '../quoterequest-presets/quoterequest-manage-preset.component';
import { QuoteRequestManagePresetComponent, QuoteRequestSavePresetComponent, QuoteRequestSavePresetModule } from './../../.';
import { appConfig } from './../../../../app.config';
import { SharedComponentsModule } from './../../../../shared-components.module';
import { UiContactSelectorModule } from './../../../messages/ui-contact-selector/ui-contact-selector.module';

interface Plan {
    ID_Plan: string;
    PlanLabel: string;
    selected: boolean;
}

interface Doc extends StorageFile {
    selected?: boolean;
}

interface EstimateMeasurement {
    ID_EstimateMeasurement: Uuid;
    Description: string;
    Measurement: string;
    UOM: string;
    selected: boolean;
}

interface Recipient {
    uniqueId: string;
    name: string;
    email: string;
    businessName?: string;
    firstName?: string;
    lastName?: string;
    mobile?: string;
    id?: string;
    isRegisteredForTax?: boolean;
    fromConnection?: boolean;
    autoCcSource?: string;
    notified?: boolean;
}

interface QuoteRequestItemAndGroupItem extends QuoteRequestItem {
    AllowQtyEdit: boolean;
    UOMUnits: number;
    DisplayedCostItemType: string;
    ID_QuoteRequestRecipeItem?: string;
    isItem: boolean;
    isRecipeItem: boolean;
    entityAspect: EntityAspect;
}

interface QuoteRequestEditStatus {
    Updated?: boolean;
    Send?: boolean;
}

@UntilDestroy()
@Component({
    selector: 'app-quoterequest-new',
    styleUrls: ['./quoterequest-view.component.scss'],
    templateUrl: './quoterequest-view.component.html',
    standalone: false,
})
export class QuoteRequestViewComponent implements OnInit {
    @Output() action = new EventEmitter();
    // @ts-ignore TS7008
    @ViewChild('contactSelector') contactSelector;

    // @ts-ignore TS7008
    config;

    quoteRequest!: BreezeCase<QuoteRequest> & QuoteRequestEditStatus;
    estimate?: Estimate;
    job?: Job;
    // @ts-ignore TS2564
    doSave: (quoteRequest) => Promise<void>;
    title = 'Quote Request Modal Controller';
    fileMode = null;
    // @ts-ignore TS7008
    originalQuoteRequest;
    // @ts-ignore TS7008
    documentsParams;
    // @ts-ignore TS2564
    dt: Date;
    dateOptions: any;
    // @ts-ignore TS7008
    disabled;
    // @ts-ignore TS2564
    currentStep: number;
    // @ts-ignore TS2564
    form: { next: () => void; prev: () => void; goTo: () => void; reset: () => void };
    // @ts-ignore TS7008
    presets;
    // @ts-ignore TS7008
    filteredPresets;
    accounts: EmailListItem[] = [];
    // @ts-ignore TS7008
    previousAccount;
    // @ts-ignore TS7008
    contactsMissingEmails;
    // @ts-ignore TS7008
    itemsWithZeroQty;
    // @ts-ignore TS7008
    supplierId;
    // @ts-ignore TS7008
    contactId;
    isBlankRFQ = false;
    unitMeasures: string[] = [];
    // @ts-ignore TS2564
    order: number;

    attachments: StorageFile[] = [];
    docs: Doc[] = [];
    plans: Plan[] = [];
    estimateMeasurements: EstimateMeasurement[] = [];
    contacts = [];
    previousRecipients = [] as Recipient[];
    previousRecipientsList = '';
    newRecipients: Recipient[] = [];
    selectedEstimateDocuments: string[] = [];
    selectedEstimatePlans: string[] = [];
    selectedEstimateMeasurements: Uuid[] = [];
    isAllDocumentsSelected: boolean = false;
    isAllMeasurementSelected: boolean = false;
    isAllPlansSelected: boolean = false;
    estimateItems: EstimateItem[] = [];
    jobItems: JobItem[] = [];
    showTakeOffLabels = false;
    titleMaxLength = 50;
    emailConfigContext = 'quoterequest';
    contactType = ContactType;

    editorOptions = {
        toolbar: {
            removeItems: [
                BxEditorToolbarItems.heading,
                BxEditorToolbarItems.fontBackgroundColor,
                BxEditorToolbarItems.fontColor,
                BxEditorToolbarItems.fontFamily,
                BxEditorToolbarItems.image,
                BxEditorToolbarItems.table,
                BxEditorToolbarItems.link,
                BxEditorToolbarItems.blockQuote,
                BxEditorToolbarItems.highlight,
                BxEditorToolbarItems.indent,
                BxEditorToolbarItems.outdent,
            ],
        },
        wproofreader: {
            serviceId: window.APP_CONFIG.webSpellCheckerServiceId,
            srcUrl: window.APP_CONFIG.webSpellCheckerServiceUrl,
        },
        ...BxEditorBase,
    };

    itemsAndGroups: QuoteRequestItemAndGroupItem[] = [];
    recipientConnections: IntegrationConnectionQuoteRequestDetailsModel[] = [];

    today = new Date();
    formStatus = FormStatus.Idle;
    // @ts-ignore TS2564
    serverErrorMessage: string;
    hasRecipes: boolean = false;
    autoCcRecipientAdded = false;

    constructor(
        private contactsService: ContactsService,
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        private bsModalRef: BsModalRef,
        private helperService: HelperService,
        private storesService: StoresService,
        private cataloguesService: CataloguesService,
        private quoteReqRepo: RepoQuoteRequestsService,
        private sharedData: SharedDataService,
        private plansRepo: RepoPlansService,
        private settings: RepoSettingsService,
        private estimatesRepo: RepoEstimatesService,
        private jobsRepo: RepoJobsService,
        private repoCommon: RepoCommonService,
        private repoContacts: RepoContactsService,
        private storageRepo: RepoStorageService,
        private dialogService: DialogService,
        public taxService: TaxService,
        private emailSendersService: EmailSendersService,
        private estimateMeasurementService: EstimateMeasurementApisService
    ) {}

    ngOnInit() {
        this.config = appConfig().config;
        this.documentsParams = {
            reference: this.quoteRequest.ID_QuoteRequest,
            hideTrashIcon: false,
            includeFolders: false,
            disableCategories: true,
            hideCategoryHeadings: true,
            uploadCallback: this.uploadCallback.bind(this),
            deleteCallback: this.deleteCallback.bind(this),
            sourceType: 'QuoteRequests',
        };

        if (this.quoteRequest && this.quoteRequest.Status === 'Open') {
            // Store the original quote request details so it can be compared when saving
            this.originalQuoteRequest = this._getQuoteRequestSnapshot();
        }

        if (this.quoteRequest.QuoteRequestItems?.length) this.setQuoteReqItemsAndGroups();
        else this.setDefaultItemsAndGroup();

        const today = new Date();
        const currentDate = new Date();
        const twoWeeksTime = today.setDate(today.getDate() + 14);
        // this.datepickerOptions = {}
        // this.datepickerOptions.initDate = new Date(twoWeeksTime) // This is not working
        // this.datepickerOptions.minDate = this.quoteRequest.DateDeadline ? new Date(this.quoteRequest.DateDeadline) : currentDate
        if (!this.quoteRequest.DateDeadline) {
            this.quoteRequest.DateDeadline = new Date(twoWeeksTime);
        }

        if (this.quoteRequest?.Title?.length > 50) {
            this.titleMaxLength = 255;
        }

        //
        this.dt = this.quoteRequest.DateDeadline; // Need a variable so we can type over model
        this.dateOptions = Object.assign({}, this.config.DATEPICKER, {
            dateDisabled: this.disabled,
            minDate: currentDate,
            initDate: new Date(twoWeeksTime),
        });

        const emailConfig = {
            To: 'info@buildxact.com.au',
            Subject: 'Test quote request email config subject',
            Body: 'Test body Test body Test body Test body Test body ',
            StorageAttachments: [
                // response.data
            ],
            references: [
                // job.ID_Job,
                // job.ID_Estimate
            ],
        };

        this.config = emailConfig;
        this.config.from = '';
        this.config.StorageAttachments = this.config.StorageAttachments || [];

        if (emailConfig.To && Array.isArray(emailConfig.To)) {
            emailConfig.To.forEach((c) => {
                if (!c.id) c.id = uuidv4();
            });
            Array.prototype.push.apply(this.newRecipients, emailConfig.To);
        }

        this.config.CCUser = this.settings.CCMyselfInEmail;
        this.config.IncludeFooter = this.settings.IncludeFooterInEmail;

        if (!this.contacts || !this.contacts.length) {
            setTimeout(() => {
                $('#emailToTags').find('input').focus();
            }, 500);
        }

        if (this.config.contacts) {
            // @ts-ignore TS7006
            this.config.contacts.forEach((c) => {
                if (!c.id) c.id = uuidv4();
            });
            Array.prototype.push.apply(this.contacts, this.config.contacts);
        } else {
            this.loadContacts();
        }

        this.storesService.refreshContacts$.pipe(untilDestroyed(this)).subscribe(() => {
            this.loadContacts();
        });

        this.storesService.newContact$.pipe(untilDestroyed(this)).subscribe((data) => {
            // Can only add into the tag list if it has been given an email.
            // No guarantee of this having occurred.
            const newContact = data;
            if (newContact.Email) {
                this.newRecipients.push({
                    name: newContact.Name,
                    businessName: newContact.BusinessName,
                    firstName: newContact.FirstName,
                    lastName: newContact.LastName,
                    email: newContact.Email,
                    mobile: newContact.Mobile,
                    id: newContact.ID_Contact,
                    isRegisteredForTax: newContact.IsRegisteredForTax,
                    uniqueId: uuidv4(),
                });
            }
        });

        this.loadUnitMeasures();
        this.loadAccounts();
        this.loadRecipientConnections();
        this._loadAttachments();
        this._loadDocuments();
        this._loadPlans();
        this._loadTakeOffs();
        this._loadRecipients();
        this._checkZeroItems();
        this._getEstimateOrJobItems();

        /******* WIZARD ********/
        this.currentStep = 1;

        const nextStep = () => {
            if (this.currentStep === 1) {
                if (this.estimate) {
                    this.updateEstimateItemQty();
                } else if (this.job) {
                    this.updateJobItemQty();
                }
            }
            this.currentStep++;
        };
        const prevStep = () => {
            this.currentStep--;
        };
        // @ts-ignore TS7006
        const goToStep = (i) => {
            this.currentStep = i;
        };

        // Initial Value
        this.form = {
            next: () => {
                nextStep();
            },
            prev: () => {
                prevStep();
            },
            // @ts-ignore TS7006
            goTo: (i) => {
                goToStep(i);
            },
            reset: () => ({}),
        };

        /* * * * * * * * */

        // Presets

        this.quoteReqRepo.GetQuoteRequestPresets().then((data) => {
            this.presets = data.results;
        });
    }

    private setQuoteReqItemsAndGroups() {
        this.itemsAndGroups = [];
        this.hasRecipes = this.quoteRequest.QuoteRequestItems?.some((item) => item.IsRecipe === true) ?? false;
        this.quoteRequest.QuoteRequestItems?.forEach((item: any) => {
            item.isItem = true;
            item.DisplayedCostItemType = this.taxService?.costItemTypeToDisplay(item.CostItemType);
            this.itemsAndGroups.push(item);
            if (!item.ID_EstimateItem && !item.ID_JobItem) this.isBlankRFQ = true;
            item.QuoteRequestRecipeItems?.forEach((recipeItem: any) => {
                recipeItem.isItem = true;
                recipeItem.isRecipeItem = true;
                this.itemsAndGroups.push(recipeItem);
            });
        });

        this.quoteRequest.QuoteRequestGroups?.forEach((group: any) => {
            group.isItem = false;
            this.itemsAndGroups.push(group);
        });

        this.itemsAndGroups.sort((l, r) => l.Order - r.Order);
        // setup default order for next item
        const order = this.itemsAndGroups[this.itemsAndGroups.length - 1]?.Order ?? 0;
        this.order = order + 1;
    }

    private setDefaultItemsAndGroup() {
        this.quoteRequest.IsStandalone = true;
        this.isBlankRFQ = true;
        this.order = 0;

        const groupData = {
            ID_QuoteRequest: this.quoteRequest.ID_QuoteRequest,
            ID_EstimateItem: undefined,
            ID_JobItem: undefined,
            Description: 'Items',
            Order: this.order++,
        };
        const quoteRequestGroup = this.quoteReqRepo.CreateGroup(groupData);
        quoteRequestGroup.isItem = false;
        this.itemsAndGroups.push(quoteRequestGroup);
        this.addNewItems();
    }

    private loadUnitMeasures() {
        this.repoCommon.GetUnitMeasures().then((results) => {
            this.unitMeasures = results.map((i) => i.Description).sort();
        });
    }

    addNewItems() {
        const defaultCostItemType = '0'; //Material
        const itemData = {
            ID_QuoteRequest: this.quoteRequest.ID_QuoteRequest,
            ID_QuoteRequestGroup: this.quoteRequest.QuoteRequestGroups?.[0]?.ID_QuoteRequestGroup,
            CalculationMethod: this.quoteRequest.CalculationMethod,
            Order: this.order++,
            Description: 'New Item',
            Quantity: 0,
            AllowQtyEdit: true,
            CostItemType: defaultCostItemType,
            DisplayedCostItemType: this.taxService?.costItemTypeToDisplay(defaultCostItemType),
        };

        this.setTaxRates(itemData);

        const quoteRequestItem = this.quoteReqRepo.CreateItem(itemData);
        quoteRequestItem.isItem = true;
        this.itemsAndGroups.push(quoteRequestItem);
        this._checkZeroItems();
    }

    private updateJobItemQty() {
        let jobUpdated = false;
        this.quoteRequest.QuoteRequestItems?.forEach((item) => {
            const jobItem = this.job?.JobItems?.find((f) => f.ID_JobItem === item.ID_JobItem);
            if (jobItem && jobItem.EstimatedQty !== item.Quantity) {
                jobItem.EstimatedQty = item.Quantity;
                jobUpdated = true;
            }
        });
        if (jobUpdated) {
            this.jobsRepo.Save([this.job, ...(this.job?.JobItems ?? [])], 'Saved');
        }
    }

    private updateEstimateItemQty() {
        let estimateUpdated = false;
        this.quoteRequest.QuoteRequestItems?.forEach((item) => {
            const estimateItem = this.estimate?.EstimateItems.find((f) => f.ID_EstimateItem === item.ID_EstimateItem);
            if (estimateItem && estimateItem.Units !== item.Quantity) {
                estimateItem.Units = item.Quantity;
                estimateUpdated = true;
            }
        });
        this.quoteRequest.QuoteRequestRecipeItems?.forEach((item) => {
            const estimateItem = this.estimate?.EstimateItems.find((f) => f.ID_EstimateItem === item.ID_EstimateItem);
            const parentItem = this.estimate?.EstimateItems.find((f) => f.ID_EstimateItem === estimateItem?.ParentID);
            if (estimateItem && parentItem && estimateItem.Units !== item.Quantity) {
                estimateItem.Units = item.Quantity;
                estimateItem.calculateUOMUnits(parentItem);
                estimateUpdated = true;
            }
        });
        if (estimateUpdated) {
            this.estimatesRepo.Save([this.estimate, ...(this.estimate?.EstimateItems ?? [])], 'Saved');
        }
    }

    updatedQuantity(quoteReqItem: QuoteRequestItem) {
        if (quoteReqItem.IsRecipe && quoteReqItem.QuoteRequestRecipeItems)
            this.calculateRecipeItemQuantity(quoteReqItem.QuoteRequestRecipeItems, quoteReqItem.Quantity);
        this._checkZeroItems();
    }

    private calculateRecipeItemQuantity(recipeItems: QuoteRequestRecipeItem[], recipeQty: number) {
        recipeItems.forEach((item: QuoteRequestRecipeItem) => {
            item.UOMUnits = this.calculateUOMUnitsForRecipeItem(item, recipeQty);
        });
    }

    calculateUOMUnitsForRecipeItem(recipeItem: QuoteRequestRecipeItem, recipeQty: number) {
        const minUnits = recipeItem.UOMMinOrderQty || 0;
        const minIncrement = recipeItem.UOMOrderIncrements || 0;
        let totalUnits = Round(recipeItem.Quantity * recipeQty, 3);
        const isNegative = totalUnits < 0;

        if (totalUnits !== 0) {
            totalUnits = Math.abs(totalUnits);
            if (totalUnits < minUnits) {
                totalUnits = Round(minUnits, 3);
            } else if (minIncrement > 0) {
                const remainder = Round((totalUnits - minUnits) % minIncrement, 3);
                if (remainder > 0) totalUnits = Round(totalUnits + (minIncrement - remainder), 3);
            }
        }

        return isNegative ? -totalUnits : totalUnits;
    }

    // @ts-ignore TS7006
    uploadCallback(file?) {
        if (file)
            // @ts-ignore TS2345
            this.attachments.push(file);
        // Mark quote request as updated
        if (this.originalQuoteRequest) this.originalQuoteRequest.attachments = true;
        // Load them in again to update counts
        this._loadAttachments();
    }

    deleteCallback() {
        if (this.originalQuoteRequest) this.originalQuoteRequest.attachments = true;
        // Update counts
        this._loadAttachments();
    }

    _getQuoteRequestSnapshot() {
        return {
            attachments: false, // abitrary value to compare with true when attachments are uploaded or deleted
            documents: false,
            plans: false,
            measurements: false,
            scopeDescription: this.quoteRequest.ScopeDescription,
            items: JSON.stringify(
                this.quoteRequest.QuoteRequestItems
                    ? // @ts-ignore TS7006
                      this.quoteRequest.QuoteRequestItems.map((item) => {
                          return {
                              id: item.ID_EstimateItem,
                              qty: item.Quantity,
                              desc: item.Description,
                              uom: item.UOM,
                          };
                      })
                    : []
            ),
        };
    }

    loadAccounts() {
        this.emailSendersService
            .getEmailSenders()
            .pipe(
                untilDestroyed(this),
                catchError((e) => {
                    return EMPTY;
                })
            )
            .subscribe((emailSenders) => {
                this.accounts = emailSenders;
                this.loadFromSelection();
                this.fromChanged();
            });
    }

    loadRecipientConnections() {
        this.cataloguesService.getOutgoingIntegrationConnectionsForQuoteRequest().subscribe((result) => {
            this.recipientConnections = result.data.outgoingIntegrationConnectionsForQuoteRequest;
            this.recipientConnections?.forEach((rc) => (rc.selected = false));
        });
    }

    // @ts-ignore TS7006
    toggleRecipientConnection(connection) {
        connection.selected = !connection.selected;
        if (connection.selected) {
            this.newRecipients.push({
                uniqueId: connection.iD_IntegrationConnection,
                name: connection.name,
                email: connection.quoteRequestEmail,
                fromConnection: true,
            });
        } else {
            // @ts-ignore TS2339
            const index = this.newRecipients.findIndex((nr) => nr.uniqueId === connection.iD_IntegrationConnection && nr.fromConnection);
            this.newRecipients.splice(index, 1);
        }
        this.contactSelector.onChange(this.newRecipients);
    }

    loadFromSelection() {
        if (this.quoteRequest?.EmailAccountId !== null) {
            this.config.from = this.quoteRequest.EmailAccountId;
            return;
        }

        const selectedSender = this.emailSendersService.loadFromSelection(this.accounts, this.emailConfigContext);
        if (selectedSender) {
            this.config.from = selectedSender.emailSenderId;
        }
    }

    saveFromSelection() {
        if (!this.accounts.length) return;

        const selectedSender = this.accounts.find((sender) => sender.emailSenderId === this.config.from);
        if (selectedSender) {
            this.emailSendersService.saveFromSelection(selectedSender, this.emailConfigContext);
        }
    }

    fromChanged() {
        const account = this.accounts.find((a) => {
            // Leave as unstrict comparison so null == undefined
            return a.emailSenderId === this.config.from;
        });
        if (account) {
            if (this.previousAccount) {
                // Remove signature
                if (this.config.Body.indexOf(this.previousAccount.signature) >= 0) {
                    this.config.Body = this.config.Body.replace(this.previousAccount.signature, '');
                }
            }
            // Only append if the signature isn't already in the email
            if (account.signature && this.config.Body.indexOf(account.signature) === -1) {
                this.config.Body += account.signature;
            }
            this.previousAccount = account;
        }
    }

    loadContacts() {
        this.repoContacts.GetAll().then(() => {
            this._loadContacts();
        });
    }

    _loadContacts() {
        const contactPersons = _.filter(this.repoContacts.AllContacts, (c) => {
            return c.$entity.ContactPersons?.length;
            // @ts-ignore TS2345
        }).map((c: viewableContact) => {
            return _.filter(c.$entity.ContactPersons, (cp) => {
                return !!cp.Email;
            }).map((cp) => {
                let personName = cp.FullName;
                if (c.businessName && c.businessName.length > 0) {
                    if (!personName || personName.length === 0) personName = c.businessName;
                    else personName += ' (' + c.businessName + ')';
                }

                return {
                    name: personName,
                    businessName: c.businessName,
                    firstName: cp.FirstName,
                    lastName: cp.LastName,
                    email: cp.Email,
                    mobile: cp.Mobile,
                    id: cp.ID_Contact,
                    isRegisteredForTax: c.isRegisteredForTax,
                    uniqueId: uuidv4(),
                    isInternal: c.isInternal,
                };
            });
        });

        const validContacts = _.filter(this.repoContacts.AllContacts, (c) => {
            return !!c.email;
        });

        let contacts = validContacts.map((c) => {
            return {
                name: c.description,
                businessName: c.businessName,
                firstName: c.firstName,
                lastName: c.lastName,
                email: c.email,
                mobile: c.mobile,
                id: c.id,
                isRegisteredForTax: c.isRegisteredForTax,
                uniqueId: uuidv4(),
                isInternal: c.isInternal,
            };
        });

        contacts = _.union(contacts, _.flatten(contactPersons));
        // @ts-ignore TS2322
        this.contacts = contacts;
        this.contactsMissingEmails = this.repoContacts.AllContacts.length - validContacts.length;
    }

    //

    // @ts-ignore TS7006
    getRecipients(query) {
        if (query)
            return this.contacts.filter((contact) => {
                return (
                    // @ts-ignore TS2339
                    contact.email &&
                    // @ts-ignore TS2339
                    contact.name &&
                    // @ts-ignore TS2339
                    (contact.email.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
                        // @ts-ignore TS2339
                        contact.name.toLowerCase().indexOf(query.toLowerCase()) >= 0)
                );
            });
        else return this.contacts;
    }

    // @ts-ignore TS7006
    contactAdded($tag) {
        // need to assign an id to the tag if it doesn't have one
        if (!$tag.id) {
            $tag.id = uuidv4();
            if (!Object.prototype.hasOwnProperty.call($tag, 'isRegisteredForTax'))
                // default isRegisteredForTax to true
                $tag.isRegisteredForTax = true;
        }
    }

    // @ts-ignore TS7006
    contactRemoved($tag) {
        if ($tag.fromConnection) {
            const recipient: any = this.recipientConnections?.find((rc) => rc.iD_IntegrationConnection === $tag.uniqueId);
            if (recipient) recipient.selected = false;
        }
    }

    _getEstimateOrJobItems() {
        if (this.quoteRequest.ID_Job) {
            this.jobsRepo.GetJobItems(this.quoteRequest.ID_Job).then((data) => {
                this.jobItems = data.results as unknown as JobItem[];
            });
        } else if (this.quoteRequest.ID_Estimate) {
            this.estimatesRepo.GetEstimateItems(this.quoteRequest.ID_Estimate).then((data) => {
                this.estimateItems = data.results as unknown as EstimateItem[];
            });
        }
    }

    _loadAttachments() {
        this.storageRepo
            .list({ reference: this.quoteRequest.ID_QuoteRequest, includeFolders: false, container: StorageContainer.documents })
            .pipe(first())
            .subscribe((data) => {
                this.attachments = data || [];
                this._decodeStoredAttachments();
            });
    }

    _loadDocuments() {
        const references: string[] = [];
        if (this.quoteRequest.ID_Estimate) references.push(this.quoteRequest.ID_Estimate);
        if (this.quoteRequest.ID_Job) references.push(this.quoteRequest.ID_Job);
        if (references.length > 0) {
            this.storageRepo
                .list({ references: references, container: StorageContainer.documents })
                .pipe(first())
                .subscribe((data) => {
                    this.docs = data;
                    this._decodeStoredAttachments();
                });
        }
    }

    _loadPlans() {
        // Only for quote requests with an estimate ID can we do this...
        if (this.quoteRequest.ID_Estimate) {
            this.plansRepo.Get(this.quoteRequest.ID_Estimate).then((response) => {
                // Got plans data
                // @ts-ignore TS2322
                this.plans = response.results || [];
                this._decodeStoredAttachments();
            });
        }
    }

    _loadTakeOffs() {
        // Only for quote requests with an estimate ID can we do this...
        if (this.quoteRequest.ID_Estimate) {
            this.estimateMeasurementService
                .getEstimateMeasurements(this.quoteRequest.ID_Estimate)
                .pipe(first())
                .subscribe((result) => {
                    // Got Estimate Measurements data for those with a ID_PlanMeasurement value
                    this.estimateMeasurements = result.data.estimateMeasurements
                        .filter((m) => m.iD_PlanMeasurement)
                        .map((m) => {
                            return {
                                ID_EstimateMeasurement: m.iD_EstimateMeasurement as Uuid,
                                Description: m.description ?? '',
                                Measurement: m.measurement.toString(),
                                UOM: m.uOM,
                                selected: false,
                            } as EstimateMeasurement;
                        });
                    if (this.estimateMeasurements.length) this._decodeStoredAttachments();
                });
        }
    }

    // @ts-ignore TS7006
    setFileMode(fileMode) {
        this.fileMode = fileMode;
    }

    removeSelectedItem(itemToRemove: QuoteRequestItemAndGroupItem) {
        if (itemToRemove.isItem) {
            const index = this._removeItem(itemToRemove);

            // If we just removed the last item inside a group
            if (
                (this.itemsAndGroups.length === index || (this.itemsAndGroups[index] && !this.itemsAndGroups[index].isItem)) &&
                !this.itemsAndGroups[index - 1]?.isItem &&
                !this.isBlankRFQ
            ) {
                itemToRemove = this.itemsAndGroups[index - 1]!;
            }

            // forcing the view to update
            if (this.isBlankRFQ && this.itemsAndGroups.length !== index) {
                const tempList = this.itemsAndGroups;
                this.itemsAndGroups = [];
                setTimeout(() => {
                    this.itemsAndGroups = [...tempList];
                });
            }
        }

        if (!itemToRemove.isItem) {
            // Remove the group itself
            const index = this.itemsAndGroups.indexOf(itemToRemove);
            this.itemsAndGroups.splice(index, 1);

            // Remove all items in the group
            for (let i = this.itemsAndGroups.length - 1; i >= 0; i--) {
                const item = this.itemsAndGroups[i];
                if (item && item?.ID_QuoteRequestGroup === itemToRemove.ID_QuoteRequestGroup) {
                    this._removeItem(item);
                }
            }
            itemToRemove.entityAspect.setDeleted();
        }

        this._checkZeroItems();
    }

    private uncheckItemToRemove(itemToRemove: QuoteRequestItemAndGroupItem) {
        _.forEach(this.estimateItems, (estimateItem) => {
            _.forEach(estimateItem.children, (childEstimateItem) => {
                if (childEstimateItem.ID_EstimateItem === itemToRemove.ID_EstimateItem) {
                    childEstimateItem.selected = false;
                }
            });
        });
    }

    private removeFromItemsList(item: QuoteRequestItemAndGroupItem) {
        const index = this.itemsAndGroups.indexOf(item);
        this.itemsAndGroups.splice(index, 1);
    }

    _removeItem(itemToRemove: QuoteRequestItemAndGroupItem) {
        // Uncheck it, as the checked selections are used later in the creation still
        if (this.estimate) this.uncheckItemToRemove(itemToRemove);

        if (itemToRemove.isRecipeItem) {
            this.quoteRequest.QuoteRequestItems?.forEach((item) => {
                item.QuoteRequestRecipeItems?.forEach((recipeItem) => {
                    if (recipeItem.ID_QuoteRequestRecipeItem === itemToRemove.ID_QuoteRequestRecipeItem) {
                        (recipeItem as unknown as BreezeEntity).entityAspect.setDeleted();
                        if (item.QuoteRequestRecipeItems?.length === 0) {
                            //remove parent item if last recipe item
                            (item as unknown as BreezeEntity).entityAspect.setDeleted();
                            this.removeFromItemsList(item as QuoteRequestItemAndGroupItem);
                            this.uncheckItemToRemove(item as QuoteRequestItemAndGroupItem);
                        }
                    }
                });
            });
        } else {
            this.quoteRequest.QuoteRequestItems?.forEach((item) => {
                // Mark entity as deleted so doesn't save
                if (item.ID_QuoteRequestItem === itemToRemove.ID_QuoteRequestItem) {
                    //remove recipe items if parent
                    const recipeItems = [...(item.QuoteRequestRecipeItems ?? [])];
                    recipeItems.forEach((recipeItem) => {
                        this.removeFromItemsList(recipeItem as unknown as QuoteRequestItemAndGroupItem);
                        (item.QuoteRequestRecipeItems?.[0] as unknown as BreezeEntity).entityAspect.setDeleted();
                    });
                    (item as unknown as BreezeEntity).entityAspect.setDeleted();
                }
            });
        }

        const index = this.itemsAndGroups.indexOf(itemToRemove);
        this.itemsAndGroups.splice(index, 1);
        return index;
    }

    private unlinkDeletedQuoteRequestItems() {
        if (this.quoteRequest.ID_Job) {
            this.unlinkJobItems();
        } else if (this.quoteRequest.ID_Estimate) {
            this.unlinkEstimateItems();
        }
    }

    private unlinkJobItems() {
        let hasChange = false;
        const quoteItemIds = new Set(this.quoteRequest.QuoteRequestItems?.map((item) => item.ID_JobItem));
        this.jobItems
            .filter((item) => item.ID_QuoteRequest === this.quoteRequest.ID_QuoteRequest)
            .forEach((jobItem) => {
                if (jobItem && !quoteItemIds.has(jobItem.ID_JobItem)) {
                    jobItem.ID_QuoteRequest = null;
                    hasChange = true;
                }
            });
        if (hasChange) this.quoteReqRepo.Save();
    }

    private unlinkEstimateItems() {
        let hasChange = false;
        const quoteItemIds = new Set(this.quoteRequest.QuoteRequestItems?.map((item) => item.ID_EstimateItem));
        this.estimateItems
            .filter((item) => item.ID_QuoteRequest === this.quoteRequest.ID_QuoteRequest)
            .forEach((estItem) => {
                if (!quoteItemIds.has(estItem.ID_EstimateItem)) {
                    estItem.ID_QuoteRequest = null;
                    hasChange = true;
                }
            });
        if (hasChange) this.quoteReqRepo.Save();
    }

    _checkZeroItems() {
        this.itemsWithZeroQty = false;
        this.quoteRequest.QuoteRequestItems?.forEach((item) => {
            if (item.Quantity === 0) this.itemsWithZeroQty = true;
        });
        this.quoteRequest.QuoteRequestRecipeItems?.forEach((item) => {
            if (item.Quantity === 0) this.itemsWithZeroQty = true;
        });
    }

    updateAllDocumentsSelection() {
        this.isAllDocumentsSelected =
            this.selectedEstimateDocuments.length !== 0 && this.selectedEstimateDocuments.length === this.docs.length;
    }

    toggleDocSelection(doc: Doc) {
        // let index = _.find(this.selectedEstimateDocuments, {storageFileName: doc.storageFileName})
        const index = this.selectedEstimateDocuments.indexOf(doc.storageFileName);

        if (!doc.selected) {
            // remove it
            this.selectedEstimateDocuments.splice(index, 1);
        } else {
            // add it
            this.selectedEstimateDocuments.push(doc.storageFileName);
        }

        this.updateAllDocumentsSelection();

        // Mark quote request as updated
        if (this.originalQuoteRequest) this.originalQuoteRequest.documents = true;
    }

    toggleAllDocumentsSelection(selectedAll: Event) {
        if (this.docs.length === 0) {
            return;
        }

        this.isAllDocumentsSelected = (selectedAll.currentTarget as HTMLInputElement).checked;

        this.selectedEstimateDocuments = [];
        this.docs.forEach((doc: Doc) => {
            if (this.isAllDocumentsSelected) {
                doc.selected = true;
                this.selectedEstimateDocuments.push(doc.storageFileName);
            } else {
                doc.selected = false;
            }
        });

        // Mark quote request as updated
        if (this.originalQuoteRequest) {
            this.originalQuoteRequest.documents = true;
        }
    }

    updateAllPlanSelection() {
        this.isAllPlansSelected = this.selectedEstimatePlans.length !== 0 && this.selectedEstimatePlans.length === this.plans.length;
    }

    togglePlanSelection(plan: Plan) {
        const index = this.selectedEstimatePlans.indexOf(plan.ID_Plan);

        if (!plan.selected) {
            // remove it
            this.selectedEstimatePlans.splice(index, 1);
        } else {
            // add it
            this.selectedEstimatePlans.push(plan.ID_Plan);
        }

        this.updateAllPlanSelection();

        // Mark quote request as updated
        if (this.originalQuoteRequest) this.originalQuoteRequest.plans = true;
    }

    toggleAllPlanSelection(selectedAll: Event) {
        if (this.plans.length === 0) {
            return;
        }

        this.isAllPlansSelected = (selectedAll.currentTarget as HTMLInputElement).checked;

        this.selectedEstimatePlans = [];
        this.plans.forEach((plan: Plan) => {
            if (this.isAllPlansSelected) {
                plan.selected = true;
                this.selectedEstimatePlans.push(plan.ID_Plan);
            } else {
                plan.selected = false;
            }
        });

        // Mark quote request as updated
        if (this.originalQuoteRequest) {
            this.originalQuoteRequest.plans = true;
        }
    }

    updateAllMeasurementSelection() {
        this.isAllMeasurementSelected =
            this.selectedEstimateMeasurements.length !== 0 && this.selectedEstimateMeasurements.length === this.estimateMeasurements.length;
    }

    toggleEstimateMeasurementSelection(estimateMeasurement: EstimateMeasurement) {
        const index = this.selectedEstimateMeasurements.indexOf(estimateMeasurement.ID_EstimateMeasurement);

        if (!estimateMeasurement.selected) {
            // remove it
            this.selectedEstimateMeasurements.splice(index, 1);
        } else {
            // add it
            this.selectedEstimateMeasurements.push(estimateMeasurement.ID_EstimateMeasurement);
        }

        this.updateAllMeasurementSelection();

        // Mark quote request as updated
        if (this.originalQuoteRequest) this.originalQuoteRequest.measurements = true;
    }

    toggleAllMeasurementSelection(selectedAll: Event) {
        if (this.estimateMeasurements.length === 0) {
            return;
        }

        this.isAllMeasurementSelected = (selectedAll.currentTarget as HTMLInputElement).checked;
        this.selectedEstimateMeasurements = [];
        this.estimateMeasurements.forEach((measurement: EstimateMeasurement) => {
            if (this.isAllMeasurementSelected) {
                measurement.selected = true;
                this.selectedEstimateMeasurements.push(measurement.ID_EstimateMeasurement);
            } else {
                measurement.selected = false;
            }
        });

        // Mark quote request as updated
        if (this.originalQuoteRequest) {
            this.originalQuoteRequest.measurements = true;
        }
    }

    _decodeStoredAttachments() {
        //
        if (!this.quoteRequest.Attachments) {
            // this.selectedEstimateDocuments    = []
            // this.selectedEstimatePlans        = []
            // this.selectedEstimateMeasurements = []
            return;
        }

        const decoded = JSON.parse(this.quoteRequest.Attachments);

        //
        this.selectedEstimateDocuments = decoded.docs && decoded.docs.length ? decoded.docs : [];
        this.selectedEstimatePlans = decoded.plans && decoded.plans.length ? decoded.plans : [];
        this.selectedEstimateMeasurements = decoded.takeoffs && decoded.takeoffs.length ? decoded.takeoffs : [];
        this.showTakeOffLabels = decoded.showTakeOffLabels;
        this.updateAllMeasurementSelection();
        this.updateAllPlanSelection();
        this.updateAllDocumentsSelection();

        //
        // Now match the selections by looping over all the docs that are loaded in, and setting selected on those, so they show as ticked in the list which gets looped over...
        //
        if (this.selectedEstimateDocuments.length) {
            for (const d of this.docs) {
                // @ts-ignore TS2339
                d.selected = this.selectedEstimateDocuments.indexOf(d.storageFileName) !== -1;
            }
        }
        //
        if (this.selectedEstimatePlans.length) {
            for (const p of this.plans) {
                // @ts-ignore TS2339
                p.selected = this.selectedEstimatePlans.indexOf(p.ID_Plan) !== -1;
            }
        }
        //
        if (this.selectedEstimateMeasurements.length) {
            for (const e of this.estimateMeasurements) {
                // @ts-ignore TS2339
                e.selected = this.selectedEstimateMeasurements.indexOf(e.ID_EstimateMeasurement) !== -1;
            }
        }
    }

    _loadRecipients() {
        if (this.quoteRequest.QuoteRequestRecipients?.length) {
            this.previousRecipients = this.quoteRequest.QuoteRequestRecipients.map((c) => {
                const contact: any = {};

                contact.id = c.ID_Contact;
                contact.email = c.Email;
                contact.name = c.FirstName + ' ' + c.LastName;

                return contact;
            });
            // pre-populate recipients for an existing RFQ
            this.newRecipients.push(
                ...this.quoteRequest.QuoteRequestRecipients.map((c) => ({
                    businessName: c.BusinessName,
                    firstName: c.FirstName,
                    lastName: c.LastName,
                    email: c.Email,
                    name: c.Name,
                    mobile: c.Mobile,
                    id: c.ID_Contact,
                    isRegisteredForTax: c.IsRegisteredForTax,
                    uniqueId: uuidv4(),
                    isPrepopulated: true, // set this property so that pre-populated ones can be filtered out
                }))
            );
        } else {
            this.previousRecipients = [];
        }
    }

    removePreviousRecipient(email: string) {
        const quoteRequestRecipient = _.find(this.quoteRequest.QuoteRequestRecipients, { Email: email });
        const quoteRequestRecipientIndex = _.indexOf(this.quoteRequest.QuoteRequestRecipients, quoteRequestRecipient);
        (quoteRequestRecipient as unknown as BreezeEntity).entityAspect.setDeleted();
        this.quoteRequest.QuoteRequestRecipients?.splice(quoteRequestRecipientIndex, 1);
        this._loadRecipients();
    }

    getCurrentPresets() {
        return _.filter(this.presets, this.filterPresetType.bind(this));
    }

    getPresetType() {
        if (this.currentStep === 2) {
            return 'Scope';
        } else {
            return 'Invitation';
        }
    }

    getPresetContent() {
        switch (this.getPresetType()) {
            case 'Scope':
                return this.quoteRequest.ScopeDescription;
            case 'Invitation':
                return this.quoteRequest.InvitationMessage;
        }
    }

    // @ts-ignore TS7006
    setContent(content) {
        switch (this.getPresetType()) {
            case 'Scope':
                this.quoteRequest.ScopeDescription = content;
                break;
            case 'Invitation':
                this.quoteRequest.InvitationMessage = content;
                break;
        }
    }

    // @ts-ignore TS7006
    filterPresetType(preset) {
        return preset.PresetType === this.getPresetType() && !preset.IsDeleted;
    }

    setTaxRates(entry: any) {
        if (this.job) {
            entry.TaxRates = this.taxService.resetItemTaxCodes(this.job.TaxRates, TaxTypeEnum.Expense, entry.CostItemType);
        }
    }

    savePresetModal() {
        const initialState = {
            savePresetsParams: () => {
                return {
                    presets: this.getCurrentPresets(),
                    type: this.currentStep === 2 ? 'Scope' : 'Invitation',
                };
            },
        };
        this.bsModalRef.setClass('modal-fade-out');
        setTimeout(() => {
            const modalRef = this.helperService.showModalAside(QuoteRequestSavePresetComponent, { initialState });

            // @ts-ignore TS2532
            modalRef.content.action.pipe(first()).subscribe((result) => {
                this.bsModalRef.setClass('modal-fade-in');
                if (!result.cancelled) {
                    if (result.presetDescription) {
                        this.saveOrUpdatePreset(result.presetDescription);
                    }
                }
            });
        }, 100);
    }

    // @ts-ignore TS7006
    saveOrUpdatePreset(desc) {
        let isExisting = false;
        let preset = _.find(this.presets, (p) => {
            return !p.IsDeleted && p.PresetType == this.getPresetType() && p.Description.toLowerCase() === desc.toLowerCase();
        });
        if (!preset) {
            preset = this.quoteReqRepo.CreateQuoteRequestPreset({
                Description: desc,
                PresetContent: this.getPresetContent(),
                PresetType: this.getPresetType(),
            });
        } else {
            isExisting = true;
            preset.PresetContent = this.getPresetContent();
        }

        this.quoteReqRepo.Save(null, 'Preset saved').then(() => {
            if (!isExisting) this.presets.push(preset);
        });
    }

    showManagePresetsModal() {
        const initialState = {
            presetParams: () => {
                return {
                    presets: this.getCurrentPresets(),
                    type: this.currentStep == 2 ? 'Scope' : 'Invitation',
                };
            },
        };
        this.bsModalRef.setClass('modal-fade-out');
        setTimeout(() => {
            const modalRef = this.helperService.showModalAside(QuoteRequestManagePresetComponent, { initialState });

            // @ts-ignore TS2532
            modalRef.content.action.pipe(first()).subscribe(() => {
                this.bsModalRef.setClass('modal-fade-in');
            });
        }, 100);
    }

    // @ts-ignore TS7006
    applyPreset(preset) {
        this.setContent(preset.PresetContent);
        this.quoteReqRepo.Save(null, 'Applied ' + preset.Description + ' to ' + this.getPresetType());
    }

    /* * * * * * * * * */

    setQuoteRequestData(send: boolean) {
        const observables = [];
        const attachmentJson: any = {};

        // Attachments
        if (this.attachments && this.attachments.length) {
            // attachmentJson.attachments     = this.attachments
            observables.push(
                this.storageRepo
                    .list({ reference: this.quoteRequest.ID_QuoteRequest, includeFolders: false, container: StorageContainer.documents })
                    .pipe(
                        first(),
                        tap((data) => {
                            attachmentJson.attachments = data;
                            // Set the JSON object on the record again.
                            this.quoteRequest.Attachments = JSON.stringify(attachmentJson);
                        })
                    )
            );
        }

        // Documents
        if (this.selectedEstimateDocuments.length) attachmentJson.docs = this.selectedEstimateDocuments;
        // Plans
        if (this.selectedEstimatePlans.length) attachmentJson.plans = this.selectedEstimatePlans;
        // Take offs / measurements
        if (this.selectedEstimateMeasurements.length) {
            attachmentJson.takeoffs = this.selectedEstimateMeasurements;
            attachmentJson.showTakeOffLabels = this.showTakeOffLabels;
        }

        this.quoteRequest.Attachments = JSON.stringify(attachmentJson);

        //From Email Accounts
        this.saveFromSelection();
        this.quoteRequest.EmailAccountId = this.config.from;

        // Create Recipient Entities here,
        const sendRecipients = this.newRecipients.filter((c: Recipient & { isPrepopulated?: unknown }) => !c.isPrepopulated); // filter out the pre-populated recipients

        observables.push(
            this.cataloguesService.getAutoCcUsersForQuoteRequest(sendRecipients.map((sr) => sr.email)).pipe(
                first(),
                tap((results) => {
                    this.autoCcRecipientAdded = results.data.autoCcUsersForQuoteRequest?.length > 0;
                    results.data.autoCcUsersForQuoteRequest?.forEach((u) => {
                        sendRecipients.push({
                            uniqueId: uuidv4(),
                            name: u.name,
                            email: u.quoteRequestEmail,
                            autoCcSource: u.sourceEmail,
                        });
                    });

                    sendRecipients.map((c) => {
                        const options: any = {};
                        options.ID_QuoteRequest = this.quoteRequest.ID_QuoteRequest;
                        options.ID_Contact = c.id;
                        options.Email = c.email;
                        options.Mobile = c.mobile || null;
                        options.Name = c.name;
                        options.BusinessName = c.businessName;
                        options.FirstName = c.firstName;
                        options.LastName = c.lastName;
                        options.IsRegisteredForTax = c.isRegisteredForTax;
                        options.AutoCcSource = c.autoCcSource;

                        // We are currently looping over all recipients and
                        this.quoteReqRepo.CreateRecipient(options);
                    });

                    this.quoteRequest.Send = send && sendRecipients?.length !== 0;
                })
            )
        );

        let isUpdated = false;
        // Check if we have a snapshot and they are the same
        if (this.originalQuoteRequest) {
            const updatedQuoteRequest = this._getQuoteRequestSnapshot();
            isUpdated = !_.isEqual(this.originalQuoteRequest, updatedQuoteRequest);
        }
        this.quoteRequest.Updated = isUpdated;

        return observables.length ? forkJoin(observables) : EMPTY;
    }

    ok() {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }

        this.formStatus = FormStatus.Saving;
        this.setQuoteRequestData(true)
            .pipe(first())
            .subscribe(() => {
                // This calls the submit func passed in...
                this.doSave(this.quoteRequest)
                    .then(() => {
                        this.formStatus = FormStatus.Saved;
                        this.resetAllCheckedSelections();
                        this.action.emit({ cancelled: false, quoteRequest: this.quoteRequest });
                        this.bsModalRef.hide();
                        if (this.autoCcRecipientAdded) {
                            this.dialogService.show({
                                title: 'Additional RFQ Recipient',
                                text: '<p><strong>A note on who receives your Request for Quote (RFQ)</strong></p><p>Additional supplier representatives have been copied in as recipients on your RFQ. This is an automatic process set up by your chosen supplier to speed up the turnaround time on your RFQ.</p>',
                                showCancel: false,
                                allowHtml: true,
                                okText: 'Ok',
                            });
                        }
                    })
                    .catch(this.saveError.bind(this));
            });
    }

    cancel() {
        // This calls the cancel func passed in...
        this.resetAllCheckedSelections();
        this.action.emit({ cancelled: true, quoteRequest: this.quoteRequest });
        this.bsModalRef.hide();
    }

    resetAllCheckedSelections() {
        // for (const plan of this.plans) {
        //     this.plans[plan].selected = false;
        // }

        this.plans.forEach((plan) => {
            // @ts-ignore TS2339
            plan.selected = false;
        });
        this.attachments.forEach((attachment) => {
            // @ts-ignore TS2339
            attachment.selected = false;
        });
        // for (const attachment of this.attachments) {
        //     this.attachments[attachment].selected = false;
        // }
        this.docs.forEach((doc) => {
            // @ts-ignore TS2339
            doc.selected = false;
        });
        // for (const doc of this.docs) {
        //     this.docs[doc].selected = false;
        // }
        this.estimateMeasurements.forEach((em) => {
            // @ts-ignore TS2339
            em.selected = false;
        });
        // for (const estimateMeasurement of this.estimateMeasurements) {
        //     this.estimateMeasurements[estimateMeasurement].selected = false;
        // }

        this.attachments = [];
        this.docs = [];
        this.plans = [];
        this.estimateMeasurements = [];
    }

    saveDraft() {
        this.formStatus = FormStatus.Saving;
        this.setQuoteRequestData(false)
            .pipe(first())
            .subscribe(() => {
                // This calls the submit func passed in...
                this.doSave(this.quoteRequest)
                    .then(() => {
                        this.unlinkDeletedQuoteRequestItems();
                        this.formStatus = FormStatus.Saved;
                        this.resetAllCheckedSelections();
                        this.action.emit({ cancelled: false, quoteRequest: this.quoteRequest });
                        this.bsModalRef.hide();
                    })
                    .catch(this.saveError.bind(this));
            });
    }

    private saveError({ message }: { message: string }): void {
        this.formStatus = FormStatus.ServerError;
        this.serverErrorMessage = message;

        // Remove added recipient entities
        if (this.quoteRequest.QuoteRequestRecipients?.length) {
            for (let i = 0; i < this.quoteRequest.QuoteRequestRecipients.length; i++) {
                const recipientEntity = this.quoteRequest.QuoteRequestRecipients[i]! as unknown as BreezeEntity;
                if (recipientEntity.entityAspect.entityState.isAdded()) {
                    recipientEntity.entityAspect.rejectChanges();
                    // Rejecting removes it from the array so need to decrement the counter
                    i--;
                }
            }
        }
    }

    // Formatters

    // @ts-ignore TS7006
    dateDeadlineFormat(newDate, quoteRequest) {
        // this method is called when 'dt' object is initially set
        // so to avoid accidently changing the status from Closed to Open, we do the following checks
        if (newDate && !moment(newDate).isSame(moment(quoteRequest.DateDeadline))) {
            const newDeadline = new Date(newDate);
            newDeadline.setHours(23);
            newDeadline.setMinutes(59);
            newDeadline.setSeconds(59);
            const todayStartOfDay = moment().startOf('day');

            // for a closed RFQ, if you choose a date in the past, it shouldn't change the status to Open
            if (moment(newDeadline).isAfter(todayStartOfDay)) {
                const previousDateDeadline = moment(quoteRequest.DateDeadline);
                quoteRequest.DateDeadline = newDeadline;
                // Change status if extending into future
                if (moment(newDeadline).isAfter(previousDateDeadline) && this.quoteRequest.Status === 'Closed') {
                    this.quoteRequest.Status = 'Open';
                }
                if (this.dt) {
                    //Reset this.dt time values to make sure that they're still midnight
                    this.dt.setHours(23);
                    this.dt.setMinutes(59);
                    this.dt.setSeconds(59);
                }
            }
        }
    }

    // Allow to add a contact, same as how it works on contact-list directive

    addContact() {
        // Todo: Make the contact name come through from the autocomplete input
        // Todo: Clear the input after the contact is added.

        /*
        Adding a timeout because there is already a modal open,
        Otherwise the newmodal layout breaks
        */
        this.bsModalRef.setClass('modal-fade-out');
        setTimeout(() => {
            this.contactsService
                .newContact({
                    Name: '',
                    preventOpen: true,
                })
                .then((contact: any) => {
                    this.supplierId = null;
                    this.contactId = contact.ID_Contact;
                    this.bsModalRef.setClass('modal-fade-in');
                    // @ts-ignore TS2345
                    this.contacts.push(contact);
                })
                .catch(() => {
                    this.bsModalRef.setClass('modal-fade-in');
                });
        });

        // Close the dropdown
        // $select.open = false
    }

    // @ts-ignore TS7006
    folderCheckGuid(folder) {
        // You will be seeing the same folder check in TabAttachments.vue - buildxact-quote-request-spa
        const r = new RegExp(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
        return r.test(folder);
    }
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BsDatepickerModule,
        TypeaheadModule,
        SharedComponentsModule,
        NgSelectModule,
        UiContactSelectorModule,
        QuoteRequestSavePresetModule,
        QuoteRequestManagePresetModule,
        BsDropdownModule,
        RouterModule,
    ],
    declarations: [QuoteRequestViewComponent],
    exports: [QuoteRequestViewComponent],
})
export class QuoteRequestViewModule {}
